import Notifications, { notes } from "@phoenixreisen/mithrils/src/notification";
import ShortNav from "../../shared/header/navigation.short.m";
import SideNav from "../../shared/header/navigation.extern.m";
import FooterView from "@phoenixreisen/mithrils/src/footer";
import Header from "../../shared/header/header.m";
import Model from "../model";
import m from "mithril";
const Footer = FooterView;
const Notes = Notifications;
export default {
    view: (v) => {
        const { webtexte } = Model;
        const { noWrapper } = v.attrs;
        return [
            m(Header, { noImg: true, noNav: false, SideNav: SideNav, ShortNav: ShortNav, version: "Phoenix Reisen - Abo-Verwaltung", headline: (webtexte === null || webtexte === void 0 ? void 0 : webtexte["katalogverwaltung__ueberschrift"]) || "Kataloge" }),
            m("div", { class: !noWrapper && "wrapper wrapper--large pt0" }, v.children),
            m(Footer, null),
            m(Notes, { list: notes }),
        ];
    },
};
